import gql from 'graphql-tag';

export const failedBankingReport = gql`
  mutation ($error: String!, $errorCode: Float, $referrerCode: String) {
    bankFeedsFailedReport(
      error: $error
      errorCode: $errorCode
      referrerCode: $referrerCode
    ) {
      success
    }
  }
`;
